/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.5.2
 */

export type EventRegistrationFormFieldBehavior = typeof EventRegistrationFormFieldBehavior[keyof typeof EventRegistrationFormFieldBehavior];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationFormFieldBehavior = {
  ALL: 'ALL',
  ALL_COPIED: 'ALL_COPIED',
  FIRST: 'FIRST',
  FIRST_APPLIED_TO_OTHERS: 'FIRST_APPLIED_TO_OTHERS',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
  MORE_THAN_THREE: 'MORE_THAN_THREE',
  HIDDEN: 'HIDDEN',
} as const;
